<template>
  <transition name="mask">
    <div v-if="$attrs.show" class="mask">
      <div class="modal-body" :style="`width: ${width}PX`">
        <div :class="`header ${hiddenNav ? 'not-nav' : ''}`">
          <div class="title">{{ title }}</div>
          <div @click="handleClose" class="close">X</div>
        </div>
        <div>
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import VueAmazingSelector from '../Select/index.vue'
export default {
  name: "OpenModal",
  props: {
    hiddenNav: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "title",
    },
    width: {
      type: Number,
      default: 600,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
  //   components: { VueAmazingSelector }
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 998;
  top: 0;
  // top: pxToVWForPad(120);
  left: 0;
} /* prettier-ignore */
.modal-body {
  position: absolute;
  top: 50%;
  background: #282828;
  z-index: 999;
  width: 600PX;

  
  left: 50%;
  transform: translate(-50%, -50%);
  .header {
    font-size: 20.3755PX;
    line-height: 29PX;
    color: #ffd591;
    height: 55PX;
    display: flex;
    justify-content: space-between;
    padding: 0 20PX;
    align-items: center;
    border-bottom: 2PX solid #ffd591;
    &.not-nav {
      justify-content: flex-end;
      border: none;
      .title {
        display: none;
      }
    }
    .close {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 450px){
    width: pxToVWForMobile(343)!important;
    .header{
      font-size: 20px;
      line-height: 28px;
    }
  }

  // @import url('./styles/index.mobile.less');
}

.mask-enter-active {
  transition: opacity 0.5s;
}
.mask-enter {
  opacity: 0;
}
.mask-leave-active {
  transition: opacity 0.5s;
}
.mask-leave-to {
  opacity: 0;
}
</style>
